import { config } from '../config'

export const baseEvent = {
  context: config.context,
} as const
